<div class="business-pin-mobile-container">
	<div>
		<app-kamona-layout [minHeight]="'calc(100vh - 232px)'">
			<div content>
				<div class="pin-wrapper">
					<div>
						<app-kamona-password-input [input]="password">
						</app-kamona-password-input>
					</div>
					<div class="m-t-16">
						<app-kamona-password-input [input]="pin">
						</app-kamona-password-input>
					</div>

					<div class="m-b-14" style="margin-top: -23px">
						<div nz-row nzAlign="middle" nzJustify="space-between">
							<div [nzTooltipTitle]="promptText" class="info-area flex-container" nz-tooltip>
								<svg fill="none" height="16" viewBox="0 0 16 16" width="16"
									 xmlns="http://www.w3.org/2000/svg">
									<path
										d="M7.99992 14.6663C4.31802 14.6663 1.33325 11.6816 1.33325 7.99967C1.33325 4.31778 4.31802 1.33301 7.99992 1.33301C11.6818 1.33301 14.6666 4.31778 14.6666 7.99967C14.6625 11.6799 11.6801 14.6623 7.99992 14.6663ZM7.33325 11.333V12.6663H8.66659V11.333H7.33325ZM7.99992 4.66634C8.7363 4.66634 9.33325 5.26329 9.33325 5.99967C9.3356 6.35349 9.19355 6.69297 8.93992 6.93967L8.11325 7.77967C7.61421 8.28082 7.33379 8.9591 7.33325 9.66634V9.99967H8.66659C8.61477 9.28301 8.90382 8.58386 9.44659 8.11301L10.0466 7.49967C10.4453 7.10255 10.6686 6.56241 10.6666 5.99967C10.6666 4.52692 9.47268 3.33301 7.99992 3.33301C6.52716 3.33301 5.33325 4.52692 5.33325 5.99967H6.66659C6.66659 5.26329 7.26354 4.66634 7.99992 4.66634Z"
										fill="#0361F0"/>
								</svg>
								What is this?

							</div>
						</div>
					</div>

					<ng-template #promptText>
						Your business transaction PIN is your secret 4 digit number you will use to authorize
						transactions like
						transfers & bill payment.
					</ng-template>
					<div class="m-t-16">
						<app-kamona-password-input [input]="confirmPin">
						</app-kamona-password-input>
					</div>
					<div *ngIf="showConfirmPinError" class="error-message">New pin and confirm pin should be same</div>

				</div>
			</div>
			<div footer>
				<div>
					<div nz-row nzAlign="middle" nzGutter="15" nzJustify="space-between">
						<div nz-col nzSpan="24">
							<div [ngClass]="{'gray-out':submitting}" class="kamona-button-session">
								<app-kamona-custom-button
									(submitForm)="submit()" [isBlock]="true"
									[isDisabled]="!form?.valid || form?.value?.pin !== form?.value?.confirmPin"
									[isSubmitting]="submitting" text="Next">
								</app-kamona-custom-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</app-kamona-layout>
	</div>
</div>
